module.exports = __webpack_public_path__ + "img/header-engagementRingsTensionRing.26c8063.jpg";